import i18n from '@/utils/i18n';
import React, { useState } from 'react';
import { Button } from '@/components/button';
import { ItemListOptionMetadata } from '@/contexts/item-context-types';
import { StyleSheet } from 'react-native';
import { useMultiOrderGuideMutations } from '@/hooks/use-multi-order-guide-mutations';
import { useToasts } from '@/contexts/toast-context';

interface Props {
  itemMetadata: ItemListOptionMetadata;
  onSaved: () => void;
  selectedVariantPackUUIDs: Set<string>;
}

export const EssentialItemActionSheetSaveButton: React.FC<Props> = ({
  itemMetadata,
  onSaved,
  selectedVariantPackUUIDs,
}) => {
  const { updateEssentialItems } = useMultiOrderGuideMutations();
  const { showErrorToast } = useToasts();

  const [mutationLoading, setMutationLoading] = useState(false);

  return (
    <Button
      containerStyle={styles.saveButton}
      loading={mutationLoading}
      onPress={async () => {
        setMutationLoading(true);
        const addedVariantPackUUIDs = Array.from(selectedVariantPackUUIDs);
        let removedVariantPackUUIDs: string[] = [];
        if (
          itemMetadata.skus.length <= 1 &&
          !selectedVariantPackUUIDs.has(itemMetadata.variantPackUUID)
        ) {
          removedVariantPackUUIDs = [itemMetadata.variantPackUUID];
        } else {
          removedVariantPackUUIDs = itemMetadata.skus.reduce<string[]>(
            (acc, sku) => {
              if (!selectedVariantPackUUIDs.has(sku.variantPackUUID)) {
                acc.push(sku.variantPackUUID);
              }
              return acc;
            },
            [],
          );
        }
        try {
          await updateEssentialItems(
            addedVariantPackUUIDs,
            removedVariantPackUUIDs,
          );

          onSaved();
        } catch {
          showErrorToast();
        }
        setMutationLoading(false);
      }}
      trackingData={{
        name: 'essential_item_sheet.save_button',
        properties: {
          nextEssentialItems: Array.from(selectedVariantPackUUIDs),
        },
      }}
    >
      {i18n.t('save')}
    </Button>
  );
};

const styles = StyleSheet.create({
  saveButton: {
    marginBottom: 8,
  },
});
